<template>
	<div class="flex xs-middle">
		<j-base-select
			size="small"
			v-model="selectInputValue"
			:options="options"
			:class="selectInputValue === 'others' ? 'xs-5' : 'xs-12'"
			@input="handleInput"
		/>
		<!-- input if occupation is others -->
		<div class="xs-7 pl1">
			<j-base-input-text
				v-if="selectInputValue === 'others'"
				v-model="textInputValue"
				class="xs-12"
				size="small"
				placeholder="Occupation"
				@input="handleInput"
			/>
		</div>
	</div>
</template>

<script>
import JBaseSelect from "@/components/JBaseSelect"
import JBaseInputText from "@/components/JBaseInputText"

export default {
	components: {
		JBaseSelect,
		JBaseInputText
	},

	props: {
		value: String,
		options: Array
	},

	data() {
		return {
			selectInputValue: this.options
				.map(({ value }) => value)
				.includes(this.value)
				? this.value
				: this.value === null
				? ""
				: "others",
			textInputValue: this.options
				.map(({ value }) => value)
				.includes(this.value)
				? ""
				: this.value
		}
	},

	methods: {
		handleInput() {
			this.$emit(
				"input",
				this.selectInputValue === "others"
					? this.textInputValue
					: this.selectInputValue
			)
		}
	}
}
</script>
